import { apiConstants } from '../../apiConstant'
import { serviceCallAuth } from '../../serviceCall'

export const getCountryCode = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.COUNTRY_CODE.GET_COUNTRY_CODE,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
